import React, { useState, useEffect } from 'react';
import '../css/BackToTop.css';

const BackToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Show button when page is scrolled up to given distance
  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // Set the top cordinate to 0
  // make scrolling smooth
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  return (
    <div className={`back-to-top ${isVisible ? 'show' : ''}`} onClick={scrollToTop} title="Back to top">
      <img src="/wp-content/uploads/arrow up.png" alt="Back to top" width="60" height="60" />
    </div>
  );
};

export default BackToTop;
